// REACT IMPORTS
import React from "react";
import { MenuList } from "../../data/NavbarMenuList";

import { MDBSideNavItem, MDBSideNavLink } from "mdb-react-ui-kit";

const SideNavComponentLoginPage = (props) => {
  return (
    <>
      {MenuList.map((k, n) => {
        return (
          <MDBSideNavItem
            key={n + 1}
            className="navigation-pill"
            onClick={() => {
              props.setBasicOpen();
            }}
          >
            <MDBSideNavLink aria-current="page" href="#" className="title">
              <div className="side-nav-text">{k.title}</div>
            </MDBSideNavLink>
          </MDBSideNavItem>
        );
      })}
    </>
  );
};

export default SideNavComponentLoginPage;
